import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ui-document-file-upload',
  templateUrl: './ui-document-file-upload.component.html',
  styleUrls: ['./ui-document-file-upload.component.scss'],
})
export class UiDocumentFileUploadComponent {
  @Input() disabled = false;
  @Input() files: Array<{ name?: string }> = [];
  @Input() showViewLink = false;
  @Input() viewLinkLabel = 'Click here to see uploaded files';
  @Input() multiple = true;
  @Input() accept = '';

  @Output() filesSelected = new EventEmitter<Event>();
  @Output() removeFile = new EventEmitter<number>();
  @Output() viewFiles = new EventEmitter<void>();

  onBrowseClick(fileInput: HTMLInputElement): void {
    if (!this.disabled) {
      fileInput.click();
    }
  }

  onFilesSelected(event: Event): void {
    this.filesSelected.emit(event);
  }

  onRemove(index: number): void {
    this.removeFile.emit(index);
  }

  onViewFiles(): void {
    this.viewFiles.emit();
  }
}
